interface LabelValue {
  value: string;
  label: string;
}

export const MAX_FILE_SIZE = 10 * 1024 * 1024; // 10MB

export const PRODUCT_CATEGORY: Record<string, LabelValue> = {
  PLASTIC: {
    value: "0",
    label: "プラスチック類",
  },
  METAL: {
    value: "1",
    label: "金属類",
  },
  WOOD: {
    value: "2",
    label: "木材類",
  },
  GLASS_CERAMIC: {
    value: "3",
    label: "ガラス・陶磁器類",
  },
  RUBBER: {
    value: "4",
    label: "ゴム類",
  },
  PAPER: {
    value: "5",
    label: "紙類",
  },
  FIBER: {
    value: "6",
    label: "繊維類",
  },
  MIXTURE_OTHER: {
    value: "7",
    label: "混合物・その他",
  },
};

export const DISPOSAL_TYPE: Record<string, LabelValue> = {
  RECYCLING: {
    value: "0",
    label: "リサイクル",
  },
  FINAL_DISPOSAL: {
    value: "1",
    label: "最終処分",
  },
  UNKNOWN: {
    value: "2",
    label: "不明",
  },
};

export const PRODUCT_STATE: Record<string, LabelValue> = {
  GOOD: {
    value: "0",
    label: "良好（未使用／未破損）",
  },
  USE: {
    value: "1",
    label: "やや使用感あり（多少の劣化・変形あり）",
  },
  DAMAGE: {
    value: "2",
    label: "破損・劣化あり（要処理・選別が必要）",
  },
  UNKNOWN: {
    value: "3",
    label: "状態不明（混合物／未確認の含有物あり）",
  },
};

export const SHIP_CHARGE_TYPE: Record<string, LabelValue> = {
  INCLUDE: {
    value: "0",
    label: "送料込み（売り手側負担）",
  },
  NOT_INCLUDE: {
    value: "1",
    label: "送料は含まれません（購入者負担）",
  },
};

export const SHIP_DAY: Record<string, LabelValue> = {
  DAY_ONE: {
    value: "0",
    label: "1〜2日で発送",
  },
  DAY_TW0: {
    value: "1",
    label: "3〜4日で発送",
  },
  DAY_THREE: {
    value: "2",
    label: "5〜6日で発送",
  },
};

export const SORT: Record<string, LabelValue> = {
  NEWEST: {
    value: "id:desc",
    label: "新着順",
  },
  LOWEST_PRICE_FIRST: {
    value: "price:asc",
    label: "価格の安い順",
  },
  HIGHEST_PRICE_FIRST: {
    value: "price:desc",
    label: "価格の高い順",
  },
};

export const COMPANY_FILTER_USER_TYPE: Record<string, LabelValue> = {
  SELLER: {
    value: "1",
    label: "売り手",
  },
  BUYER: {
    value: "2",
    label: "買い手",
  },
};

export const COMPANY_FILTER_STATUS_TYPE: Record<string, LabelValue> = {
  PENDING_REVIEW: {
    value: "0",
    label: "審査待ち",
  },
  REJECTED: {
    value: "2",
    label: "否認済",
  },
};

export const COMPANY_FILTER_SORT: Record<string, LabelValue> = {
  NEWEST: {
    value: "id:desc",
    label: "新着順",
  },
  APPLICATION_DATE: {
    value: "updated_at:desc",
    label: "申請日順",
  },
};

export const COMPANY_MANAGE_FILTER_STATUS_TYPE: Record<string, LabelValue> = {
  APPROVED: {
    value: "1",
    label: "有効",
  },
  FROZEN: {
    value: "3",
    label: "凍結中",
  },
};

export const COMPANY_MANAGE_FILTER_SORT: Record<string, LabelValue> = {
  NEWEST: {
    value: "id:desc",
    label: "新着順",
  },
  COMPANY_NAME: {
    value: "company_name:asc",
    label: "法人名順",
  },
  LAST_LOGIN: {
    value: "last_login:desc",
    label: "最終ログイン順",
  },
};

export const EXHIBIT_FILTER_SORT: Record<string, LabelValue> = {
  LIST_DATE: {
    value: "id:desc",
    label: "出品日順",
  },
  ESTABLISH_DATE: {
    value: "updated_at:desc",
    label: "成立日順",
  },
};

export const TRANSACTION_HISTORY_FILTER_SORT: Record<string, LabelValue> = {
  FINAL_UPDATE: {
    value: "id:desc",
    label: "最終更新順",
  },
  ESTABLISH_DATE: {
    value: "updated_at:desc",
    label: "成立日順",
  },
};

export const INQUIRY_FILTER_USER_TYPE: Record<string, LabelValue> = {
  ABOUT_LIST: {
    value: "1",
    label: "出品について",
  },
  ABOUT_TRANSACTION: {
    value: "2",
    label: "取引について",
  },
  ABOUT_ISSUE: {
    value: "3",
    label: "不具合について",
  },
  OTHER: {
    value: "4",
    label: "その他",
  },
};

export const INQUIRY_FILTER_STATUS_TYPE: Record<string, LabelValue> = {
  UNRESOLVED: {
    value: "1",
    label: "未対応",
  },
  PROCESSING: {
    value: "2",
    label: "対応中",
  },
  INQUIRY_CLOSED: {
    value: "3",
    label: "お問い合わせ終了",
  },
};

export const INQUIRY_FILTER_SORT: Record<string, LabelValue> = {
  NEWEST: {
    value: "id:desc",
    label: "新着順",
  },
  FINAL_UPDATE: {
    value: "updated_at:desc",
    label: "最終更新順",
  },
  STATUS: {
    value: "status:desc",
    label: "ステータス順",
  },
};

export const PAST_INQUIRY_FILTER_SORT: Record<string, LabelValue> = {
  NEWEST: {
    value: "id:desc",
    label: "新着順",
  },
  OLDEST: {
    value: "id:asc",
    label: "古い順",
  },
};

export const QUEST_PAGE_SIZE = 10;
export const QUEST_PROGRESS_PAGE_SIZE = 10;
export const DEFAULT_HIDDEN_QUEST_CODES = [
  "HIDDEN_FAST_MULTI_DEAL",
  "HIDDEN_DEAL_VETERAN",
  "HIDDEN_VOLUME_TITAN",
];

export const QUEST_TABLE_GRID_COLUMNS =
  "grid-cols-[180px_minmax(420px,1fr)_100px_120px_120px_90px_160px]";

export const QUEST_PROGRESS_TABLE_GRID_COLUMNS =
  "grid-cols-[200px_minmax(710px,1fr)_200px]";

export const QUEST_ACTION_OPTIONS = [
  { label: "ログイン", value: "user_login" },
  { label: "取引交渉開始", value: "transaction_negotiation_started" },
  { label: "取引完了", value: "transaction_completed" },
  { label: "メッセージ送信", value: "message_sent" },
  { label: "メッセージ返信", value: "message_replied" },
  { label: "出品完了", value: "product_published" },
  { label: "クエスト報酬受取", value: "quest_claimed" },
];

export const QUEST_TARGET_ROLE_OPTIONS = [
  { label: "すべて", value: "all" },
  { label: "買い手", value: "buyer" },
  { label: "売り手", value: "seller" },
];

export const QUEST_LOGIN_CONDITION_OPTIONS = [
  { label: "累計ログイン", value: "count" },
  { label: "連続ログイン", value: "streak" },
];

export const BADGE_TIER_LABELS: Record<string, string> = {
  gold: "ゴールド",
  silver: "シルバー",
  bronze: "ブロンズ",
};

export const QUEST_PROGRESS_TYPE_LABELS = {
  monthly: "マンスリークエスト",
  hidden: "隠しクエスト",
} as const;
